import { Directive, ElementRef, HostListener, Output, EventEmitter } from '@angular/core';

@Directive({
  selector: '[appMRNFilter]',
})
export class MrnFilterDirective {
  @Output() onValidate = new EventEmitter<boolean>(); // Emits a string
  //year-country-office departure-sequential number-procedure identifier-check digit{21-DE-3302-12345678-E-9}
  private regex: RegExp = new RegExp(/^\d{2}[A-Za-z]{2}\d{4}\d{8}[A-Za-z]{1}\d{1,2}$/g);

  //
  constructor(private el: ElementRef) {}

  //capture keys and ctrl-v
  @HostListener('keyup', ['$event']) onKeyUp(e: KeyboardEvent) {
    let current: string = this.el.nativeElement.value;

    if (current && String(current).match(this.regex) == null) {
      this.el.nativeElement.style = 'border-color:red';
      this.onValidate.emit(false);
    } else {
      this.onValidate.emit(true);
      this.el.nativeElement.style = 'border-color:grey';
    }
  }

  //capture right-click paste event
  @HostListener('paste', ['$event']) onPaste(e: ClipboardEvent) {
    return;
  }
}
